import React from "react";
import { TablePagination } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const TableFooter = ({
  count = 0,
  handlePageChange = () => {},
  handleLimitChange = () => {},
  rowsPerPage = 10,
  page = 0,
}) => {
  const { t } = useTranslation();
  return (
    <TablePagination
      component="div"
      count={count}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handleLimitChange}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[5, 10, 25]}
      labelRowsPerPage={t("table.rows_per_page")}
      backIconButtonText={t("table.prev_page")}
      nextIconButtonText={t("table.next_page")}
    />
  );
};

export default TableFooter;
